module.exports = __webpack_public_path__ + "img/1.62f2e456.png";